import React, { useState } from "react";
import ContainerEventsQuery from "../Components/ContainerEventsQuery";
import ImgProfileTogether from "../medias/Freestyle_Swimming_Stroke copier.jpg";
import Select from "react-select";
import Regions from "../Data/ListRegions";
import listSwimEnv from "../Data/ListSwimEnv";
import triDiscover from "../medias/pexels-mali-maeder-1415810.jpg";

export const Dompter = () => {
  const [region, setSelectedRegion] = useState({
    value: "Ile-de-France",
    label: "Ile-de-France",
  });
  const [littleRace, setLittleRace] = useState(false);
  const [swim, setSwim] = useState(listSwimEnv);
  const handleRegion = (region) => {
    setSelectedRegion(region);
  };
  const handleSizeRace = () => {
    setLittleRace(littleRace ? false : true);
  };
  const handleSwim = (selectedSwim) => {
    setSwim(selectedSwim);
  };
  console.log("swim", swim);
  return (
    <section>
      {/* header */}
      <div className="container mt-5">
        <div className="pt-3 visible-sm"></div>
        <h1 className="text-warning">
          Dépasser ses peurs en choisissant certains parcours
        </h1>
        <br />
        <div className="row mb-md-5">
          <div className="col-md-2">
            <img
              src={ImgProfileTogether}
              alt="Profil débutant"
              className="d-block mx-auto w-100 mb-3"
            />
            <h2 style={{ fontSize: "1rem", fontWeight: "bold" }}>
              Choisir son terrain de prédilection
            </h2>
          </div>
          <div className="col-md-6 mb-3 pr-5">
            Deux types de peurs peuvent freiner le sportif qui veut réaliser un
            triathlon&nbsp;: se confronter à une foule de triathlètes et la
            gestion de l'environnement lui-même. Ainsi, on peut être très bon
            nageur en piscine, mais craindre les profondeurs. Ou, avoir peur de
            se prendre des claques en natation quand il ne s'agit pas d'être
            frôlés par des cyclistes à fond dans des descentes périlleuses.
            C'est pourquoi, en cas d'appréhension ou de phobie, il vaut mieux
            étudier le terrain et se préparer mentalement...
          </div>
          {/* header right part */}
          <div className="col-md-4 px-1"></div>
        </div>
      </div>
      {/* page left part*/}
      <div className="row my-2">
        <div className="col-md-8">
          <div className="row mb-4">
            <div className="col-md-4">
              <h5 className="text-warning">
                Se ménager un environnement favorable
              </h5>
              <p>
                L'entraînemnt est une répétition générale de l'enchaînement des
                disciplines. Pour le triathlète, il s'agit également d'une
                préparation mentale. Mais la perspective de réaliser son épreuve
                dans un environnement estimé comme difficile ou dangereux
                constitue un autre écueil à appréhender. <br />
                Le nombre de participants, des départs en natation avec ou sans
                rolling start (vagues de départ), des routes étroites ou de
                qualité médiocre, en pleine nature ou en milieu urbain...
                Beaucoup de paramètres peuvent être anticipés afin de vivre au
                mieux son triathlon.
              </p>
            </div>
            <div className="col-md-8">
              <h3 className="font-weight-bold">
                Big épreuves{" "}
                <span className="text-primary">
                  ou environnements "confortables"
                </span>
              </h3>
              <div className="row">
                <div className="col-md-5">
                  <h6 className="ml-3 font-weight-bold">
                    Choisir votre région
                  </h6>
                  <Select
                    defaultValue="Ile-de-France"
                    onChange={handleRegion}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={Regions}
                    value={region}
                    placeholder="Votre région"
                  />
                </div>
                <div className="col-md-1"></div>
                <div className="col-md-5">
                  <h6 className="font-weight-bold">
                    Moins de 100 participants ?
                  </h6>
                  <label>Oui</label>
                  <input
                    type="checkbox"
                    className="ml-2"
                    name={"Oui"}
                    checked={littleRace}
                    onChange={handleSizeRace}
                  />
                </div>
              </div>
              <ContainerEventsQuery
                region={region.value}
                remove={false}
                format={["XS", "S", "M", "L", "XL", "XXL"]}
                relay={""}
                Elevation_bike={0}
                Elevation_run={0}
                bibs={25000}
                Swimenv={[
                  "Piscine",
                  "Lac",
                  "Mer",
                  "Rivière",
                  "Plan d'eau",
                  "0",
                ]}
                crosstri={["1", "0"]}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <h5 className="text-warning">
                Choisir votre triathlon en fonction de la natation : en piscine,
                lac, mer, rivière ou canal, plan d'eau ?
              </h5>
              <p>
                La première partie du triathlon, la natation est souvent un
                facteur de stress ou l'occasion d'affronter certaines phobies.
                Le milieu aquatique, la promiscuité de la masse de concurrents,
                la nécessité de se repérer, le fait de voir ou non le fond de
                l'eau... Autant de points qui peuvent amener le sportif à
                renoncer. C'est pourquoi le choix de la natation peut dans
                certains cas être stratégique. Vais-je partir par vague de
                quelques triathlètes toutes les 2 secondes ou en mass start en
                courant sur l'air de départ&nbsp;? Verrais-je les bords du canal
                ou de la rivière sur le parcours natation&nbsp;? Choisirais-je
                exclusivement une natation en piscine&nbsp;?
              </p>
            </div>
            <div className="col-md-8">
              <h3 className="font-weight-bold">
                Sélectionner son triathlon en fonction de la natation&nbsp;:{" "}
                <span className="text-primary">
                  piscine, lac, mer, rivière ou canal, plan d'eau ?
                </span>
              </h3>
              <img src={triDiscover} alt="triathlon Goran Bogicevic" />
              <h6 className="ml-3 mt-3 font-weight-bold">
                Choisir le type de natation
              </h6>
              <Select
                defaultValue="Piscine"
                onChange={handleSwim}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                options={listSwimEnv}
                value={swim}
                className="col-md-6 pl-0"
                placeholder="Site de natation"
              />
              <ContainerEventsQuery
                region={region.value}
                remove={false}
                format={["XS", "S", "M", "L", "XL", "XXL"]}
                relay={""}
                Elevation_bike={0}
                //Elevation_run={0}
                bibs={25000}
                Swimenv={[swim.value]}
                crosstri={["1", "0"]}
              />
            </div>
          </div>
        </div>
        {/* page right part*/}
        <div className="col-md-4">
          <div className="container bg-primary py-3">
            <div className="">
              <h4 className="font-weight-bold mb-1">
                Conseils : préparer, répéter, visualiser
              </h4>
              <p>
                Combien de triathlètes ne se sont pas présentés au départ d'une
                course pour cause de phobie&nbsp;? Que le degré d'appréhension
                ou de peur soit élevé ou plus léger, le phénomène est loin
                d'être négligeable. Si le choix du terrain et de l'épreuve
                peuvent réduire ce stress, l'athlète devra surtout se préparer.
                La répétition lors de l'entraînement de conditions similaires
                aident énormément.
              </p>
              <p>
                C'est tout bonnement la préparation mentale. La préparation du
                matériel, les longues heures passées sur le vélo, la natation en
                eau libre si possible avec d'autres, les enchaînements... Chaque
                geste répété concourt au bon déroulement de sa course.
                Visualiser chaque étape est le secret. Et pour ceux qui ont
                besoin d'accompagnement, la sophrologie qui anticipe les moments
                difficiles avec des gestes à exécuter pour les dépasser peut
                être un véritable atout.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
